module.exports = __webpack_public_path__ + "static/media/SWSCRC1-01.8460539c.mp3";